
import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { donationData, DonationType } from "./donation-data";
import { DonationButton } from "./DonationButton";
import { DonationDetailsDialog } from "./DonationDetailsDialog";

interface Product {
  id: number;
  title: string;
  name: string;
  description: string;
  price: number;
  priceId: string;
  icon: LucideIcon;
  isDonation: boolean;
  slug: DonationType;
}

interface ProductCardProps {
  product: Product;
  onPurchase: (name: string) => void;
  isOpen?: boolean;
  onOpenChange?: (value: string | undefined) => void;
  id?: string;
}

export function ProductCard({ product, isOpen, onOpenChange, id }: ProductCardProps) {
  const IconComponent = product.icon;
  const details = donationData[product.slug];

  return (
    <Card className="flex flex-col h-full relative z-10" id={id}>
      <Accordion 
        type="single" 
        collapsible 
        className="h-full"
        value={isOpen ? `item-${product.id}` : undefined}
        onValueChange={(value) => onOpenChange?.(value)}
      >
        <AccordionItem value={`item-${product.id}`} className="border-none h-full">
          <div className="p-4">
            <div className="flex items-center gap-3">
              <IconComponent className="w-6 h-6 md:w-8 md:h-8 text-purple-600 flex-shrink-0" />
              <AccordionTrigger className="hover:no-underline">
                <h3 className="text-base md:text-lg font-semibold text-left">{product.name}</h3>
              </AccordionTrigger>
            </div>
            <AccordionContent className="overflow-visible">
              <p className="text-xs md:text-sm text-muted-foreground my-3">{product.description}</p>
              <div className="flex flex-col gap-2 mt-3">
                <div className="flex justify-between items-center">
                  <span className="text-sm md:text-base font-semibold">${product.price.toFixed(2)}</span>
                  <DonationButton 
                    priceId={product.priceId}
                    price={product.price}
                    isCompact={true}
                  />
                </div>
                <DonationDetailsDialog
                  title={details.title}
                  description={details.description}
                  fullDescription={details.fullDescription}
                  price={details.price}
                  priceId={details.priceId}
                  icon={details.icon}
                  name={product.name}
                />
              </div>
            </AccordionContent>
          </div>
        </AccordionItem>
      </Accordion>
    </Card>
  );
}
